import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues, change } from 'redux-form';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { SELECTION_LETTERS_FORM_NAME } from 'Common/FormEnum';
import { SelectionLettersForm } from './components/SelectionLettersForm';
import { SelectionLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { LoadingPage, YesNoDialog } from 'Components/';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { createToast, toastType } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  getSelectionLetters,
  clearReport,
  getInitialData,
  writeSuccess,
} from './state/selectionletters/actions';

class SelectionLettersContainer extends Component {
  state = {
    showSuccessModal: false,
  };

  defaultValues = {
    [Fields.LetterDate]: defaultDateFormat(moment()),
    [Fields.ShowSiteName]: true,
    [Fields.ReceivedDate]: defaultDateFormat(moment()),
    [Fields.CompletedDate]: defaultDateFormat(moment()),
    [Fields.PrintUnprinted]: true,
    [Fields.UseStudentAddress]: false,
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: SELECTION_LETTERS_FORM_NAME,
        saveButtonProps: {
          content: 'Print',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getInitialData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Selection Letters');
        this.setState({ showSuccessModal: true });
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    this.props.getSelectionLetters(formValues);
  };

  onPrintSuccess = () => {
    this.props.writeSuccess(this.props.selectedHouseholds);
    this.setState({ showSuccessModal: false });
    this.props.change(Fields.StaffName, '');
    this.props.change(Fields.StaffPhone, '');
  };

  render() {
    const { formValues, loading, data, writing } = this.props;
    const { showSuccessModal } = this.state;

    return (
      <Fragment>
        {loading ? <LoadingPage /> : undefined}
        <Filter title={'Selection Letters'} />
        <Main {...this.getMainProps()}>
          <SelectionLettersForm
            onSubmit={this.handleSubmit}
            initialValues={{
              ...(formValues ? formValues : this.defaultValues),
              [Fields.PrintedCount]: data ? data[Fields.PrintedCount] : null,
              [Fields.UnprintedCount]: data
                ? data[Fields.UnprintedCount]
                : null,
            }}
            formValues={formValues ? formValues : {}}
            writing={writing}
          />
        </Main>
        <YesNoDialog
          showDialog={showSuccessModal}
          title={'Was printing successful?'}
          question={
            <span>
              Do you want to confirm selection for these applications now?
              <br />
              Once confirmed, applications cannot be removed from verification.
            </span>
          }
          yesCallback={this.onPrintSuccess}
          noCallback={() => {
            this.setState({ showSuccessModal: false });
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues(SELECTION_LETTERS_FORM_NAME)(state),
    loading: state.SelectionLettersState.selectionLetters.fetching,
    report: state.SelectionLettersState.selectionLetters.report,
    data: state.SelectionLettersState.selectionLetters.data,
    selectedHouseholds:
      state.SelectionLettersState.selectionLetters.selectedHouseholds,
    writing: state.SelectionLettersState.selectionLetters.writing,
  };
};

export const SelectionLetters = withRouter(
  connect(mapStateToProps, {
    getSelectionLetters,
    clearReport,
    getInitialData,
    writeSuccess,
    change,
  })(SelectionLettersContainer)
);



// WEBPACK FOOTER //
// ./src/pages/selectionletters/SelectionLetters.js